import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState, type Dispatch, type SetStateAction } from "react";
import { toast } from "sonner";

export const useAttendance = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{
    load: boolean;
    save: boolean;
  }>({ load: false, save: false });

  const loadAttendance = async (
    classId: string,
    setAttendance: Dispatch<
      SetStateAction<{
        class: any;
        session: any;
        exploration: any;
        roster: {
          student: {
            _id: string;
            name: string;
            email: string;
            gradYear: number;
          };
          present: boolean;
          reason: string;
        }[];
      }>
    >,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, load: true }));
      const response = await api(
        `/attendance/${classId}`,
        { method: "GET" },
        dispatch,
      );
      setAttendance({
        roster: response.roster,
        class: response.class,
        session: response.session,
        exploration: response.exploration,
      });
    } catch (error: any) {
      return toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, load: false }));
    }
  };

  const saveAttendance = async (
    classId: string,
    entries: {
      studentId: string;
      present: boolean;
    }[],
  ) => {
    try {
      setLoading((prev) => ({ ...prev, save: true }));
      const response = await api(
        `/attendance/${classId}`,
        { method: "POST", body: { entries } },
        dispatch,
      );
      toast.success(response.message);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, save: false }));
    }
  };

  return { loadAttendance, saveAttendance, loading };
};
